import React, { useRef, useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import { apiPut } from "../../utils/apiFetch";
import OButton from "components/reusable/OButton";
import { useNavigate, useLocation } from "react-router-dom";
import apiPath from "../../utils/apiPath";
import { apiGet } from "../../utils/apiFetch";
import useToastContext from "hooks/useToastContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OFile from "components/reusable/OFile";
import { validationRules } from "utils/constants";
const EditBlog = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [profilePic, setProfilePic] = useState(location?.state?.file || null);
  const [addMerchantLoading, setAddMerchantLoading] = useState(false);
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(location.state);
  const [file, setFile] = useState([]);
  const [removedFiles, setRemovedFiles] = useState([]);
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {},
  });

  const handleFileChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(image);
    if (isValidImage) {
      setProfilePic(image);
    } else {
      setProfilePic(null);
    }
  };

  const validateFiles = (profilePic) => {
    let picError = "";
    const supportedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!isEmpty(supportedTypes.includes(profilePic.type))) {
      picError = "Only jpeg, jpg and png are supported.";
    }
    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError("");
      return true;
    }
  };

  const getBack = () => {
    setRedirect(true);
    navigate("/blogs");
  };

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      setCategories(response?.docs);
      return response?.docs
    }
  };

  const getSubCategories = (categoryId) => {
    const category = categories.filter((item) => {
      return item?._id === categoryId;
    });
    setSubCategories(category[0]?.subcategories);
    return category[0]?.subcategories
  };
  useEffect(() => {
    // getCategories();
    // if (Object.keys(editData).length !== 0 && editData !== undefined) {
    //   setValue("title", editData.title ?? "");
    //   setValue("categoryId", editData?.category ?? "");
    //   setValue("subCategoryId", editData?.subCategory ?? "");
    //   setValue("authorName", editData?.authorName ?? "");
    //   setValue("description", editData?.description ?? "");
    //   setFile(editData?.files);
    // }
    async function fetchData() {
      const getdata = await getCategories();
      const getSubCatData = await getSubCategories(editData?.category);
      if (Object.keys(editData).length !== 0 && editData !== undefined) {
        setValue("title", editData.title ?? "");
        setValue("authorName", editData?.authorName ?? "");
        setValue("description", editData?.description ?? "");
        setFile(editData?.files);
        const categoryExist = getdata.filter((item) => {
          return item._id === editData.category
        })
        if (categoryExist.length > 0) {
          setValue("categoryId", editData?.category ?? "");
        }
        const subCategoryExist = getSubCatData.filter((item) => {
          return item._id === editData.subCategory
        })
        if (subCategoryExist.length > 0) {
          setValue("subCategoryId", editData?.subCategory ?? "");
        }
      }
    }
    fetchData()
  }, [editData, categories.length]);

  useEffect(() => {
    getSubCategories(editData?.category);
  }, [editData, categories.length]);

  const addMore = (item) => {
    handleFileUpload(item.target.files);
  };
  const remove = (index) => {
    if (index?.flag === 'fromApi') {
      const dbUrl = index?.url?.split("com/");
      const thumbnailUrl = !isEmpty(index?.thumbnail) ? index?.thumbnail?.split("com/") : '';
      setRemovedFiles([...removedFiles, { type: index?.type, url: dbUrl[1], thumbnail: thumbnailUrl[1] || '' }]);
    }
    setFile((prev) => {
      return prev.filter((res) => res !== index);
    });
  };
  const handleFileUpload = (e) => {
    for (let i = 0; i < e?.length; i++) {
      let getType = e[i].type.split("/");
      if (
        getType[1] !== undefined &&
        (getType[1] === "jpeg" ||
          getType[1] === "png" ||
          getType[1] === "jpg" ||
          getType[1] === "gif" ||
          getType[1] === "mp4")
      ) {
        setFile((prev) => {
          if (prev?.length > 0) {
            return [...prev, e[i]];
          } else {
            return [e[i]];
          }
        });
      } else {
        notification.error("Only jpeg,png,jpg,gif, mp4 formats are allowed");
      }
    }
  };

  const validate = () => {
    if (file?.length > 5) {
      notification.error("You cannot upload more than 5 files");
      return false;
    } else if (file?.length < 1) {
      notification.error("Please choose photo/video");
      return false;
    }
    for (let i = 0; i < file?.length; i++) {
      const size = file[i]?.size / (1024 * 1024).toFixed(2)
      if (size && size > 50) {
        notification.error("You cannot upload file of more than 50mb.");
        return false;
      }
    }
    return true;
  };

  const onSubmit = async (data) => {
    try {
      let valid = validate();
      if (valid) {
        const path = apiPath.ListBlog + "/" + location?.state?._id;
        const formData = new FormData();
        formData.append("title", data.title);
        formData.append("category", data.categoryId);
        formData.append("subCategory", data.subCategoryId);
        formData.append("authorName", data.authorName);
        formData.append("description", data?.description);
        if (file?.length > 0) {
          for (let i = 0; i < file?.length; i++) {
            formData.append("files", file[i]);
          }
        }
        formData.append("removedFiles", removedFiles?.length > 0 ? JSON.stringify(removedFiles) : JSON.stringify([]));
        const result = await apiPut(path, formData);
        if (result?.data?.success) {
          setRedirect(true);
          notification.success(result.data.message);
        } else {
          notification.error(result.data.message);
        }
      }
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
  };

  if (is_redirect) {
    return navigate("/blogs");
  }

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          {t("EDIT_BLOG")}
        </h2>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="title"
                  id="title"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={100}
                  {...register("title", {
                    required: t("VALIDATION_TITLE_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_TITLE_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("title", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="title"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_TITLE")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.title?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="authorName"
                  id="authorName"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("authorName", {
                    required: t("VALIDATION_AUTHOR_REQUIRED"),
                    pattern: {
                      value: validationRules.characters,
                      message: t("VALIDATION_AUTHOR_PATTERN"),
                    },
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_AUTHOR_MIN_LENGTH")
                        : val.length > 30
                          ? t("VALIDATION_AUTHOR_MAX_LENGTH")
                          : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("authorName", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="authorName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_AUTHOR_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.authorName?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="categoryId"
                  name="categoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("categoryId", {
                    required: t("VALIDATION_SELECT_CATEGORY"),
                    onChange: (e) => {
                      getSubCategories(e.target.value);
                    },
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_CATEGORY")}
                  </option>
                  {categories &&
                    categories.length !== 0 &&
                    categories?.map(({ title, _id }) => (
                      <option
                        key={_id}
                        value={_id}
                        selected={_id === editData?.category}
                      >
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="categoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORY")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.categoryId?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="subCategoryId"
                  name="subCategoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("subCategoryId", {
                    required: false,
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_SUB_CATEGORY")}
                  </option>
                  {subCategories &&
                    subCategories.length !== 0 &&
                    subCategories?.map(({ title, _id }) => (
                      <option
                        key={_id}
                        value={_id}
                        selected={_id === editData?.subCategory}
                      >
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="subCategoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_SUBCATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.subCategoryId?.message} />
              </div>
            </div>
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  type="text"
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("description", {
                    required: t("VALIDATION_DESCRIPTION_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_DESCRIPTION_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("description", value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.description?.message} />
              </div>
            </div>

            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
              <div className="text-center">
                <OButton
                  label={t("O_EDIT")}
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                {t("O_UPLOAD_IMAGE_VIDEO")}
              </h3>
            </div>
            <div className="flex relative text-center h-full items-baseline justify-center border border-dashed mb-5 rounded-sm p-[20px] min-h-[158px]">
              <input
                className="absolute opacity-0 top-0 right-0 left-0 bottom-0 cursor-pointer"
                type="file"
                onChange={(e) => {
                  addMore(e);
                }}
                multiple
                accept="image/png, image/jiffy, image/jpeg, image/jpg, video/mp4"
                onClick={(e) => (e.target.value = null)}
              />
              <div className="flex flex-col items-center">
                <img src="/images/photoupload.svg" className="mb-2" />
                <strong>{t("ADD_MORE")}</strong>
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  {t("MAX_5_FILE_UPLOAD_TITLE")}
                </span>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-5">
              {file?.length > 0 &&
                file?.map((res, index) => {
                  return (
                    <div className="relative" key={index}>
                      <figure className="">
                        {res?.type === "video/mp4" || res?.type === "video" ? (
                          <video
                            controls
                            className="h-48 w-48"
                            src={
                              typeof res === "object" &&
                                res?.flag !== "fromApi"
                                ? URL.createObjectURL(res)
                                : res?.url
                            }
                          />
                        ) : (
                          <img
                            className="h-48 w-48"
                            src={
                              typeof res === "object" &&
                                res?.flag !== "fromApi"
                                ? URL.createObjectURL(res)
                                : res?.url
                            }
                            alt="img"
                          />
                        )}
                      </figure>
                      <a
                        href="javascript:void(0)"
                        onClick={() => remove(res)}
                        className="absolute top-3 right-11"
                      >
                        <img src="/images/photo-crose.svg" alt='img' />
                      </a>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBlog;
